import React from 'react'
import { createStackNavigator } from '@react-navigation/stack'
import CollectingWavesPage from './CollectingWavesPage'
import LightStatePage from './LightStatePage'
import SendingWavesPage from './SendingWavesPage'
import WhichCallDoctorPage from './WhichCallDoctorPage'
import WhichYellowWavesPage from './WhichYellowWavesPage'
import {
  backWebOption, closeOption, noNav,
} from '../../navigators/NavigatorOptions'
import AllGreenButtonPage from './AllGreenButtonPage'
import FlashingHeartButtonPage from './FlashingHeartButtonPage'
import LatitudeIndicatorPage from './LatitudeIndicatorPage'
import NoLightsButtonPage from './NoLightsButtonPage'
import OneCollectingWavesPage from './OneCollectingWavesPage'
import OneSendingWavePage from './OneSendingWavePage'
import RedCallDoctorPage from './RedCallDoctorPage'
import ThreeCollectingWavesPage from './ThreeCollectingWavesPage'
import ThreeSendingWavesPage from './ThreeSendingWavesPage'
import TwoCollectingWavesPage from './TwoCollectingWavesPage'
import TwoSendingWavesPage from './TwoSendingWavesPage'
import YellowCallDoctorPage from './YellowCallDoctorPage'
import WhereToPlaceMonitorPage from '../CommSetup/WhereToPlaceMonitorPage'
// import WhereToPlaceMonitorPage from "../Setup/WhereToPlaceMonitorPage";
// import PatientManualComponentPage from "mobile/app/components/PatientManualPage";

const Stack = createStackNavigator()

const webViewPages = (sameWebView) => (
  <>
    <Stack.Screen name="AllGreenButtonPage" component={AllGreenButtonPage} options={backWebOption('AllGreenButtonPage', sameWebView)} />
    <Stack.Screen name="FlashingHeartButtonPage" component={FlashingHeartButtonPage} options={backWebOption('FlashingHeartButtonPage', sameWebView)} />
    <Stack.Screen name="LatitudeIndicatorPage" component={LatitudeIndicatorPage} options={backWebOption('LatitudeIndicatorPage', sameWebView)} />
    <Stack.Screen name="NoLightsButtonPage" component={NoLightsButtonPage} options={backWebOption('NoLightsButtonPage', sameWebView)} />
    <Stack.Screen name="OneCollectingWavesPage" component={OneCollectingWavesPage} options={backWebOption('OneCollectingWavesPage', sameWebView)} />
    <Stack.Screen name="OneSendingWavePage" component={OneSendingWavePage} options={backWebOption('OneSendingWavePage', sameWebView)} />
    <Stack.Screen name="RedCallDoctorPage" component={RedCallDoctorPage} options={backWebOption('RedCallDoctorPage', sameWebView)} />
    <Stack.Screen name="ThreeCollectingWavesPage" component={ThreeCollectingWavesPage} options={backWebOption('ThreeCollectingWavesPage', sameWebView)} />
    <Stack.Screen name="ThreeSendingWavesPage" component={ThreeSendingWavesPage} options={backWebOption('ThreeSendingWavesPage', sameWebView)} />
    <Stack.Screen name="TwoCollectingWavesPage" component={TwoCollectingWavesPage} options={backWebOption('TwoCollectingWavesPage', sameWebView)} />
    <Stack.Screen name="TwoSendingWavesPage" component={TwoSendingWavesPage} options={backWebOption('TwoSendingWavesPage', sameWebView)} />
    <Stack.Screen name="YellowCallDoctorPage" component={YellowCallDoctorPage} options={backWebOption('YellowCallDoctorPage', sameWebView)} />
    <Stack.Screen name="WhereToPlaceMonitorPage" component={WhereToPlaceMonitorPage} options={closeOption('WhereToPlaceMonitorPage')} />
    <Stack.Screen name="WhichCallDoctorPage" component={WhichCallDoctorPage} options={backWebOption('WhichCallDoctorPage', sameWebView)} />
    <Stack.Screen name="WhichYellowWavesPage" component={WhichYellowWavesPage} options={backWebOption('WhichYellowWavesPage', sameWebView)} />
    <Stack.Screen name="CollectingWavesPage" component={CollectingWavesPage} options={backWebOption('CollectingWavesPage', sameWebView)} />
    <Stack.Screen name="SendingWavesPage" component={SendingWavesPage} options={backWebOption('SendingWavesPage', sameWebView)} />
  </>
)

// export function TroubleshootingLightsStack() {
//     return (
//       <Stack.Navigator initialRouteName="LightStatePage">
//         <Stack.Screen name="LightStatePage" component={LightStatePage} options={hiddenItem(true)} />
//         {webViewPages(true)}
//       </Stack.Navigator>
//
//     )
// }

// eslint-disable-next-line func-names
const Screen = (backOption) => function () {
  return (
    <Stack.Navigator initialRouteName="LightStatePage">
      <Stack.Screen
        name="LightStatePage"
        component={LightStatePage}
        options={backOption}
      />
      {webViewPages(true)}
    </Stack.Navigator>
  )
}

export const TroubleshootingLightsStack = Screen(backWebOption('IndicatorLights', true, 'pop', 'troubleshooting:troubleshootingTitle'))
export const IndicatorLightsWithBackButton = Screen(backWebOption('IndicatorLights', true, 'pop', 'common:indicatorLightsTitle'))
export default Screen(noNav('common:indicatorLightsTitle', 'large'))
